/**
 * @generated SignedSource<<f0467ace764701b94d8fe04fe656baf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFunnelInput = {
  clientMutationId?: string | null;
  funnelId: string;
};
export type FunnelListTabContainer_Mutation$variables = {
  input: DeleteFunnelInput;
  connections: ReadonlyArray<string>;
};
export type FunnelListTabContainer_MutationVariables = FunnelListTabContainer_Mutation$variables;
export type FunnelListTabContainer_Mutation$data = {
  readonly deleteFunnel: {
    readonly deletedFunnelId: string;
  } | null;
};
export type FunnelListTabContainer_MutationResponse = FunnelListTabContainer_Mutation$data;
export type FunnelListTabContainer_Mutation = {
  variables: FunnelListTabContainer_MutationVariables;
  response: FunnelListTabContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedFunnelId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelListTabContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteFunnelPayload",
        "kind": "LinkedField",
        "name": "deleteFunnel",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelListTabContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteFunnelPayload",
        "kind": "LinkedField",
        "name": "deleteFunnel",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedFunnelId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e567b0a4481f6d6149226131b404178",
    "id": null,
    "metadata": {},
    "name": "FunnelListTabContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelListTabContainer_Mutation(\n  $input: DeleteFunnelInput!\n) {\n  deleteFunnel(input: $input) {\n    deletedFunnelId\n  }\n}\n"
  }
};
})();

(node as any).hash = "253b6d0d339c6a46ebef26ceabcc2cc1";

export default node;
